import { Component, signal, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { APP_CONFIG } from '../../config/app.config.constants';

@Component({
  selector: 'app-navigation',
  standalone: true,
  imports: [CommonModule, RouterModule],
  template: `
    <nav class="navbar" [class.scrolled]="isScrolled()">
      <div class="nav-container">
        <div class="nav-brand">
          <a routerLink="/" class="brand-link">
            <img [src]="APP_CONFIG.IMAGES.LOGO" alt="Kalaivani Logo" class="brand-logo">
            <span class="brand-text">Kalaivani</span>
          </a>
        </div>
        
        <button 
          class="mobile-menu-toggle" 
          [class.active]="mobileMenuOpen()"
          (click)="toggleMobileMenu()"
          [attr.aria-expanded]="mobileMenuOpen()"
          aria-label="Toggle menu"
        >
          <svg class="hamburger-icon" [class.active]="mobileMenuOpen()" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" width="24" height="24">
            <path class="hamburger-line line-1" stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16"/>
          </svg>
          <svg class="close-icon" [class.active]="mobileMenuOpen()" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" width="24" height="24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>

        <!-- Desktop Menu -->
        <ul class="nav-menu desktop-menu">
          <li><a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Home</a></li>
          <li><a routerLink="/features" routerLinkActive="active">Features</a></li>
          <li><a routerLink="/benefits" routerLinkActive="active">Benefits</a></li>
          <li><a routerLink="/pricing" routerLinkActive="active">Pricing</a></li>
          <li><a routerLink="/demo" routerLinkActive="active">Demo</a></li>
          <li><a routerLink="/contact" routerLinkActive="active">Contact</a></li>
        </ul>

        <div class="mobile-menu-overlay" [class.active]="mobileMenuOpen()" (click)="closeMobileMenu()"></div>
        <div class="mobile-menu-wrapper" [class.active]="mobileMenuOpen()">
          <div class="mobile-menu-header">
            <div class="mobile-menu-logo">
              <img src="/logo.png" alt="Kalaivani Logo" class="mobile-logo-img">
              <span class="mobile-logo-text">Kalaivani</span>
            </div>
            <button class="mobile-menu-close" (click)="closeMobileMenu()" aria-label="Close menu">
              <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" width="24" height="24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
              </svg>
            </button>
          </div>
          <ul class="nav-menu mobile-menu" [class.active]="mobileMenuOpen()">
          <li>
            <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="closeMobileMenu()">
              <svg class="nav-icon" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
              </svg>
              <span>Home</span>
            </a>
          </li>
          <li>
            <a routerLink="/features" routerLinkActive="active" (click)="closeMobileMenu()">
              <svg class="nav-icon" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              <span>Features</span>
            </a>
          </li>
          <li>
            <a routerLink="/benefits" routerLinkActive="active" (click)="closeMobileMenu()">
              <svg class="nav-icon" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"/>
              </svg>
              <span>Benefits</span>
            </a>
          </li>
          <li>
            <a routerLink="/pricing" routerLinkActive="active" (click)="closeMobileMenu()">
              <svg class="nav-icon" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              <span>Pricing</span>
            </a>
          </li>
          <li>
            <a routerLink="/demo" routerLinkActive="active" (click)="closeMobileMenu()">
              <svg class="nav-icon" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"/>
                <path stroke-linecap="round" stroke-linejoin="round" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              <span>Demo</span>
            </a>
          </li>
          <li>
            <a routerLink="/contact" routerLinkActive="active" (click)="closeMobileMenu()">
              <svg class="nav-icon" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
              </svg>
              <span>Contact</span>
            </a>
          </li>
          <li>
            <a routerLink="/signup" routerLinkActive="active" (click)="closeMobileMenu()">
              <svg class="nav-icon" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"/>
              </svg>
              <span>Sign Up</span>
            </a>
          </li>
          
          <!-- Social Media Section -->
          <li class="mobile-social-section">
            <div class="social-section-title">Follow Us</div>
            <div class="mobile-social-links">
              <a [href]="APP_CONFIG.SOCIAL_MEDIA.FACEBOOK" aria-label="Facebook" class="mobile-social-link" target="_blank" rel="noopener noreferrer">
                <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/>
                </svg>
              </a>
              <a [href]="APP_CONFIG.SOCIAL_MEDIA.LINKEDIN" aria-label="LinkedIn" class="mobile-social-link" target="_blank" rel="noopener noreferrer">
                <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/>
                  <path stroke-linecap="round" stroke-linejoin="round" d="M4 6a2 2 0 100-4 2 2 0 000 4z"/>
                </svg>
              </a>
              <a [href]="APP_CONFIG.SOCIAL_MEDIA.YOUTUBE" aria-label="YouTube" class="mobile-social-link" target="_blank" rel="noopener noreferrer">
                <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"/>
                </svg>
              </a>
              <a [href]="APP_CONFIG.SOCIAL_MEDIA.TWITTER" aria-label="Twitter" class="mobile-social-link" target="_blank" rel="noopener noreferrer">
                <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84"/>
                </svg>
              </a>
            </div>
          </li>
        </ul>
        </div>

        <a routerLink="/signup" class="btn btn-primary nav-cta-button">Start Free Trial</a>
      </div>
    </nav>
  `,
  styles: [`
    .navbar {
      position: fixed;
      top: 48px;
      left: 0;
      right: 0;
      background: rgba(255, 255, 255, 0.95);
      backdrop-filter: blur(10px);
      box-shadow: var(--shadow-sm);
      z-index: 1000;
      transition: all 0.3s ease;
      padding: 0 40px;
    }

    .navbar.scrolled {
      box-shadow: var(--shadow-md);
    }

    .nav-container {
      max-width: 1400px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 100px;
    }

    .nav-brand {
      display: flex;
      align-items: center;
    }

    .brand-link {
      display: flex;
      align-items: center;
      gap: 12px;
      text-decoration: none;
    }

    .brand-logo {
      height: 90px;
      width: auto;
      object-fit: contain;
      flex-shrink: 0;
    }

    .brand-text {
      display: none;
      font-size: 1.25rem;
      font-weight: 700;
      color: var(--primary-color);
      white-space: nowrap;
    }

    .nav-menu {
      display: flex;
      list-style: none;
      gap: 40px;
      align-items: center;
      margin: 0;
      padding: 0;
      font-family: 'Inter', sans-serif;
    }

    .nav-menu li a {
      color: var(--text-secondary);
      font-weight: 500;
      font-size: 16px;
      font-family: 'Inter', sans-serif;
      transition: all 0.3s ease;
      position: relative;
      padding: 8px 12px;
      text-decoration: none;
      border-radius: 6px;
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .nav-icon {
      width: 20px;
      height: 20px;
      flex-shrink: 0;
    }

    .nav-menu li a:hover {
      color: var(--accent-color);
    }

    .nav-menu li a.active {
      color: var(--accent-color);
      font-weight: 600;
    }

    .nav-menu li a.active::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 3px;
      background: var(--accent-color);
      border-radius: 3px 3px 0 0;
    }


    /* Button styles now use centralized classes from styles.scss */
    .nav-cta-button {
      padding: 10px 24px;
      font-size: 16px;
    }
    
    .nav-menu li a.demo-button {
      padding: 10px 24px;
    }


    .mobile-menu-toggle {
      display: none;
      background: none;
      border: none;
      cursor: pointer;
      padding: 10px;
      z-index: 1001;
      position: relative;
      min-width: 44px;
      min-height: 44px;
      color: var(--primary-color);
    }

    .mobile-menu-overlay,
    .mobile-menu-wrapper {
      display: none;
    }

    .hamburger-icon,
    .close-icon {
      width: 24px;
      height: 24px;
      transition: all 0.3s ease;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .hamburger-icon {
      opacity: 1;
    }

    .hamburger-icon.active {
      opacity: 0;
      transform: translate(-50%, -50%) rotate(90deg);
    }

    .close-icon {
      opacity: 0;
      transform: translate(-50%, -50%) rotate(-90deg);
    }

    .close-icon.active {
      opacity: 1;
      transform: translate(-50%, -50%) rotate(0deg);
    }

    .hamburger-line {
      transition: all 0.3s ease;
    }

    @media (max-width: 968px) {
      .navbar {
        padding: 0 20px;
      }

      .nav-container {
        height: 90px;
      }

      .desktop-menu {
        gap: 24px;
      }

      .desktop-menu li a {
        font-size: 14px;
      }
    }

    @media (max-width: 768px) {
      .navbar {
        top: 0;
        padding: 0 16px;
      }

      .nav-container {
        height: 60px; /* Reduced from 70px for better mobile space usage */
        padding: 0;
      }

      .brand-logo {
        height: 44px; /* Reduced from 50px, still visible but more compact */
      }

      .brand-text {
        display: block;
        font-size: 1rem; /* Reduced from 1.1rem for better mobile fit */
        margin-left: 8px;
      }

      .desktop-menu {
        display: none;
      }

      .nav-cta-button.btn {
        display: none;
      }

      .mobile-menu-toggle {
        display: flex;
      }

      .mobile-menu-overlay {
        display: block;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.6);
        backdrop-filter: blur(4px);
        z-index: 999;
        opacity: 0;
        visibility: hidden;
        transition: opacity 0.3s ease, visibility 0.3s ease;
      }

      .mobile-menu-overlay.active {
        opacity: 1;
        visibility: visible;
      }

      .mobile-menu-wrapper {
        display: flex;
        position: fixed;
        top: 0;
        left: 0;
        width: 320px;
        max-width: 85vw;
        height: 100vh;
        background: white;
        box-shadow: 2px 0 20px rgba(0, 0, 0, 0.15);
        transform: translateX(-100%);
        transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        z-index: 1000;
        flex-direction: column;
        overflow: hidden;
      }

      .mobile-menu-wrapper.active {
        transform: translateX(0);
      }

      .mobile-menu.active {
        transform: translateX(0);
      }

      .mobile-menu-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px 20px; /* Reduced from 20px 24px for better mobile spacing */
        border-bottom: 1px solid var(--border-color);
        background: var(--bg-light);
        min-height: 70px; /* Reduced from 80px */
      }

      .mobile-menu-logo {
        display: flex;
        align-items: center;
        gap: 12px;
        max-width: calc(100% - 60px);
        overflow: hidden;
      }

      .mobile-logo-img {
        height: 40px;
        width: auto;
        object-fit: contain;
      }

      .mobile-logo-text {
        font-size: 1.25rem;
        font-weight: 700;
        color: var(--primary-color);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .mobile-menu-close {
        background: none;
        border: none;
        padding: 8px;
        cursor: pointer;
        color: var(--text-primary);
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 44px;
        min-height: 44px;
        border-radius: 8px;
        transition: all 0.3s ease;
      }

      .mobile-menu-close:hover {
        background: rgba(0, 0, 0, 0.05);
      }

      .mobile-menu {
        flex: 1;
        overflow-y: auto;
        overflow-x: hidden;
        padding: 0;
        margin: 0;
        list-style: none;
        display: flex;
        flex-direction: column;
        gap: 0;
        -webkit-overflow-scrolling: touch;
      }

      .mobile-menu li {
        width: 100%;
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);
      }

      .mobile-menu li a {
        width: 100%;
        padding: 16px 20px; /* Reduced from 18px 24px for better mobile spacing */
        display: flex;
        align-items: center;
        gap: 12px; /* Reduced from 16px */
        border-radius: 0;
        font-size: 16px; /* Maintain readable size */
        min-height: 56px; /* Reduced from 60px but still touch-friendly (above 44px minimum) */
        transition: all 0.2s ease;
        color: var(--text-primary);
        text-decoration: none;
        font-weight: 500;
      }

      .mobile-menu li a span {
        color: var(--text-primary);
      }

      .mobile-menu li a .nav-icon {
        color: var(--text-secondary);
      }

      .mobile-menu li a:active {
        background: rgba(249, 115, 22, 0.1);
        transform: scale(0.98);
      }

      .mobile-menu li a.active::after {
        display: none;
      }

      .mobile-menu li a.active {
        background: rgba(249, 115, 22, 0.12);
        border-left: 4px solid var(--accent-color);
        padding-left: 20px;
        color: var(--accent-color);
        font-weight: 600;
      }

      .nav-icon {
        width: 24px;
        height: 24px;
        flex-shrink: 0;
        color: inherit;
      }

      .mobile-social-section {
        margin-top: auto;
        padding: 0;
        border-top: 2px solid var(--border-color);
        background: linear-gradient(135deg, rgba(30, 58, 138, 0.03) 0%, rgba(16, 185, 129, 0.03) 100%);
      }

      .social-section-title {
        padding: 16px 20px 10px; /* Reduced from 20px 24px 12px */
        font-size: 0.875rem;
        font-weight: 700;
        color: var(--text-primary);
        text-transform: uppercase;
        letter-spacing: 0.1em;
        text-align: center;
      }

      .mobile-social-links {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 12px;
        padding: 0 20px 20px; /* Reduced from 0 24px 24px */
      }

      .mobile-social-link {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 48px;
        height: 48px;
        padding: 0;
        color: var(--text-secondary);
        text-decoration: none;
        transition: all 0.2s ease;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.8);
        border: 1px solid var(--border-color);
        min-width: 48px;
        min-height: 48px;
        position: relative;
      }

      .mobile-social-link:active {
        background: rgba(249, 115, 22, 0.15);
        transform: scale(0.95);
        border-color: var(--accent-color);
        color: var(--accent-color);
      }

      .mobile-social-link svg {
        width: 20px;
        height: 20px;
        color: var(--text-primary);
        fill: none;
        stroke: currentColor;
        stroke-width: 2;
        flex-shrink: 0;
        display: block;
      }

      .mobile-social-link:active svg,
      .mobile-social-link:hover svg {
        color: var(--accent-color);
      }

      .mobile-social-link:active svg {
        color: var(--accent-color);
      }

      .mobile-menu-close svg {
        color: var(--text-primary);
      }

      .nav-icon {
        color: var(--text-secondary);
      }
    }

    @media (max-width: 480px) {
      .navbar {
        padding: 0 12px;
      }

      .nav-container {
        height: 56px; /* Further reduced for very small screens */
      }

      .brand-logo {
        height: 40px; /* Further reduced for very small screens */
      }

      .brand-text {
        font-size: 0.9375rem; /* Slightly smaller but still readable */
        margin-left: 6px;
      }
      
      .mobile-menu-header {
        padding: 12px 16px; /* Further reduced for very small screens */
        min-height: 64px;
      }
      
      .mobile-menu li a {
        padding: 14px 16px; /* Further reduced for very small screens */
        min-height: 52px; /* Still above 44px minimum */
      }
    }
  `]
})
export class NavigationComponent {
  APP_CONFIG = APP_CONFIG;
  isScrolled = signal(false);
  mobileMenuOpen = signal(false);

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.isScrolled.set(window.scrollY > 20);
  }

  toggleMobileMenu() {
    this.mobileMenuOpen.update(val => !val);
  }

  closeMobileMenu() {
    this.mobileMenuOpen.set(false);
  }
}

